<div class="paginator">
  <div class="per-page">
    <label for="paginator-per-page">{{ 'paginator.per_page' | translate }}</label>

    <div class="select-wrapper">
      <select
        id="paginator-per-page"
        #perPageSelect
        [disabled]="isLoading()"
        (change)="setItemPerPage.emit(+perPageSelect.value)"
      >
        @for (option of itemsPerPageOptions; track option) {
          <option [value]="option" [selected]="itemsPerPage() === option">{{ option }}</option>
        }
      </select>
      <kin-icon name="arrow_bottom" [size]="16" [color]="colorService.neutral900()" />
    </div>

    <p class="item-count">
      {{
        'paginator.item_range'
          | translate
            : {
                first: displayedFirstItem(),
                last: displayedLastItem(),
                total: displayedTotalItems(),
              }
      }}
    </p>
  </div>

  <nav class="pages" [attr.aria-label]="'paginator.pagination' | translate">
    <button
      type="button"
      class="arrow"
      [disabled]="isFirstPage() || isLoading()"
      [attr.aria-label]="'paginator.previous' | translate"
      (click)="previousPage.emit()"
    >
      <kin-icon
        name="arrow_left"
        [size]="20"
        [color]="isFirstPage() ? colorService.neutral300() : colorService.neutral900()"
      />
    </button>

    @for (item of pages(); track $index) {
      @if (item === ellipsis) {
        <span class="ellipsis">
          <span class="ellipsis-label" aria-hidden="true">…</span>
          <select
            #jumpSelect
            class="ellipsis-select"
            [disabled]="isLoading()"
            [attr.aria-label]="'paginator.go_to_page' | translate"
            (change)="goToSelectedPage(jumpSelect)"
          >
            @for (pageNumber of allPages(); track pageNumber) {
              <option [value]="pageNumber" [selected]="pageNumber === displayedPage()">
                {{ pageNumber }}
              </option>
            }
          </select>
        </span>
      } @else {
        <button
          type="button"
          class="page"
          [class.active]="item === displayedPage()"
          [disabled]="isLoading()"
          [attr.aria-current]="item === displayedPage() ? 'page' : null"
          (click)="goToPage.emit(item)"
        >
          {{ item }}
        </button>
      }
    }

    <button
      type="button"
      class="arrow"
      [disabled]="isLastPage() || isLoading()"
      [attr.aria-label]="'paginator.next' | translate"
      (click)="nextPage.emit()"
    >
      <kin-icon
        name="arrow_right"
        [size]="20"
        [color]="isLastPage() ? colorService.neutral300() : colorService.neutral900()"
      />
    </button>
  </nav>
</div>
